import { createContext } from 'react';

import type { useBoolean } from '@/_shared';

export type SecondarySidebarContextValue = ReturnType<typeof useBoolean>;

export const SecondarySidebarContext = createContext<SecondarySidebarContextValue | undefined>(undefined);
